/**
 * @generated SignedSource<<436739aa74c14042a70811a30453ff53>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SellerAwayBanner_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useSellerAwayCopy_seller">;
  readonly " $fragmentType": "SellerAwayBanner_seller";
};
export type SellerAwayBanner_seller$key = {
  readonly " $data"?: SellerAwayBanner_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"SellerAwayBanner_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SellerAwayBanner_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useSellerAwayCopy_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "73d5513262f32bf4114c23ac35428bd4";

export default node;
